export const compareTwoStrings = (string, another_string) => {
  return string === another_string || "Os endereços de email não coincidem";
};